import layoutHeaderAside from '@/layout/header-aside'

const meta = { requiresAuthA: true }

export default {
  path: '/',
  name: 'patient',
  meta,
  redirect: { name: 'patient-manager' },
  component: layoutHeaderAside,
  children: (pre => [
    { path: 'patientManager/main', name: `${pre}manager`, component: () => import('@/pages/patientManager/main'), meta: { meta, title: '患者管理' } },
    { path: 'patientManager/linkPage', name: `${pre}linkPage`, component: () => import('@/pages/patientManager/linkPage'), meta: { meta, title: '患者绑定' } },
    { path: 'patientManager/addPage', name: `${pre}addPage`, component: () => import('@/pages/patientManager/addPage'), meta: { meta, title: '新增患者' } },
    { path: 'patientManager/detailPage', name: `${pre}detailPage`, component: () => import('@/pages/patientManager/detailPage'), meta: { meta, title: '患者详情' } }
  ])('patient-')
}
